import {CREATE_GROWTH_PATH_START} from "../../types";

export const create_growth_path = (payload) => ({
  type: CREATE_GROWTH_PATH_START,
  payload,
});
